import React from 'react';
import { CircleMarker, Polygon, Polyline } from 'react-leaflet';
import { splitPoints, splitPosition } from '../../actions/spectrumActions';
import Predicates from '../../constants/predicates';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import MAP from 'constants/mapConstants';

require('react-leaflet-markercluster/dist/styles.min.css');

export default function MapSearchResultComponent(props) {
  const { searchResults } = props;

  if (searchResults && searchResults.length > 0) {
    const points = [];
    const polygonsAndLines = [];

    searchResults.forEach(res => {
      if (res.locationType === Predicates.PROFIUM.POINT) {
        points.push(res);
      } else {
        polygonsAndLines.push(res);
      }
    });

    if (points.length === 0 && polygonsAndLines.length === 0) {
      return null;
    } else {
      return (
        <div>
          {
            polygonsAndLines.length > 0 && polygonsAndLines.map((result, i) => {
              const pointStrings = splitPosition(result.location);
              if (result.locationType === Predicates.PROFIUM.POLYGON){
                return (
                  <Polygon
                    positions={splitPoints(pointStrings, true)}
                    uri={result.objectURI}
                    color={MAP.DEFAULT_COLOR}
                    key={i}>
                  </Polygon>
                );
              }
              else{
                return (
                  <Polyline
                    positions={splitPoints(pointStrings, false)}
                    uri={result.objectURI}
                    color={MAP.DEFAULT_COLOR}
                    key={i}>
                  </Polyline>
                );
              }
            })
          }
          {
            points.length > 0 &&
            <MarkerClusterGroup>
              {
                points.map((result, i) => {
                  const pointStrings = splitPosition(result.location);
                  return (
                    <CircleMarker
                      center={splitPoints(pointStrings, false)[0]}
                      uri={result.objectURI}
                      color={MAP.DEFAULT_COLOR}
                      radius={MAP.MARKER_RADIUS}
                      key={i}>
                    </CircleMarker>
                  );
                })
              }
            </MarkerClusterGroup>
          }
        </div>
      );
    }
  } else {
    return null;
  }
}